import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-config',
    templateUrl: './config.component.svg',
    styleUrls: ['./config.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfigComponent {}
